import { useContext } from 'react'
import { ActivitiesContext } from './context'

export function useActivitiesContext() {
  const context = useContext(ActivitiesContext)

  if (context === undefined)
    throw Error('Must be descendant of ActivitiesContextProvider')

  return context
}
